import { Component, OnInit } from '@angular/core';
import { AssigTripsService } from '../../../assigntrips-service/assigntrips-service';

@Component({
  selector: 'app-planner-mapper-list',
  templateUrl: './planner-mapper-list.component.html',
  styleUrls: ['./planner-mapper-list.component.css']
})
export class PlannerMapperListComponent implements OnInit {
  // filterList=[];
  search="";
  templates = [];
  
  constructor(
    private assignTripsService: AssigTripsService
  ) { }

  ngOnInit() {
    this.getTemplates();
  }

  getTemplates() {
    this.assignTripsService
      .getPlannerTemplates()
      .subscribe(data => {
        if (data && data.length) {
          this.templates = data;
        }
      });
  }

}
